// extracted by css-extract-rspack-plugin
export default {"general":"General_general__SMw-Y"};